import { Routes, Route, Link } from "react-router-dom";
import About from "./About";
import Projects from "./Projects";
import Resume from "./Resume";
import Fun from "./Fun";
import "./Navbar.css";

function NavBar() {
  const menuItems = [
    { name: "About", link: "/", component: About },
    { name: "Projects", link: "/projects", component: Projects },
    { name: "Resume", link: "/resume", component: Resume },
    { name: "Fun", link: "/fun", component: Fun },
  ];

  return (
    <div>
      <nav>
        <ul>
          {menuItems.map((item, index) => (
            <li key={index} className="menu-item">
              <Link to={item.link}>{item.name}</Link>
            </li>
          ))}
        </ul>
      </nav>
      <main>
        <Routes>
          {menuItems.map((item, index) => (
            <Route key={index} path={item.link} element={<item.component/>} />
          ))}
        </Routes>
      </main>
    </div>
  );
}

export default NavBar;
